import { Injectable } from "@angular/core";
import { getRandomHexColor } from "@globals/helper-functions";
import { FeatureGroup } from "leaflet";
import { BiMapArea } from "../BiMapArea";
import { BiMapComponentAddressModel } from "../BiMapComponentAddressModel";

@Injectable()
export class BiMapPropertiesHandlerService {
  /**
   * Feature group holding all the markers and properties (matrikler in Danish) that are currently on map. Properties are polygons created through GeoJSON
   */
  private propertiesLayerGroup = new FeatureGroup();
  private usedColorsForProperties: { [key: string]: string } = {};

  constructor() {}

  public setupPropertyAreaManagement(map: L.Map) {
    map.addLayer(this.propertiesLayerGroup);

    map.on(L.Draw.Event.DELETESTART, () => {
      this.propertiesLayerGroup.getLayers().map(l => {
        if (l instanceof BiMapArea && l.type === "property") {
          l.bringToBack();
        }
      });
    });

    map.on(L.Draw.Event.DELETESTOP, () => {
      this.propertiesLayerGroup.getLayers().map(l => {
        if (l instanceof BiMapArea && l.type === "property") {
          l.bringToFront();
        }
      });
    });
  }

  public getCurrentProperties() {
    return this.propertiesLayerGroup.getLayers() as Array<BiMapArea>;
  }

  public getPropertyByAddressDisplayValue(addressDisplayValue: string) {
    return this.propertiesLayerGroup.getLayers().find((property: BiMapArea) => {
      const addr = property.address as BiMapComponentAddressModel;
      return addr?.displayValue === addressDisplayValue;
    });
  }

  public removeProperty(property: BiMapArea) {
    this.propertiesLayerGroup.removeLayer(property);

    // Don't remove the color if there still exists a property with the same ID
    const propertyId = (property.address as BiMapComponentAddressModel)?.displayValue;

    if (propertyId && !this.getPropertyByAddressDisplayValue(propertyId) && this.usedColorsForProperties[propertyId]) delete this.usedColorsForProperties[propertyId];
  }

  public clearProperties() {
    this.propertiesLayerGroup.clearLayers();
    this.usedColorsForProperties = {};
  }

  public addPropertiesToMap(properties: Array<BiMapArea>, map: L.Map) {
    properties.forEach(property => {
      const propertyId = (property.address as BiMapComponentAddressModel).displayValue;

      let propertyColor = getRandomHexColor();

      if (this.usedColorsForProperties[propertyId]) propertyColor = this.usedColorsForProperties[propertyId];
      else {
        while (Object.values(this.usedColorsForProperties).includes(propertyColor)) propertyColor = getRandomHexColor();

        this.usedColorsForProperties[propertyId] = propertyColor;
      }

      property.setStyle({ fillColor: propertyColor, color: propertyColor });

      this.propertiesLayerGroup.addLayer(property);
    });

    if (!map.hasLayer(this.propertiesLayerGroup)) map.addLayer(this.propertiesLayerGroup);
  }
}
